import * as React from 'react'

type SubRoute = {
  planningVersions: (id: string) => string
  index: () => string
}

const Context = React.createContext<SubRoute | null | undefined>(null)

interface Props {
  baseRoute: SubRoute
}

export const RouteProvider = ({ children, baseRoute }: React.PropsWithChildren<Props>) => {
  return <Context.Provider value={baseRoute}>{children}</Context.Provider>
}

export const useRoute = (): SubRoute => {
  const route = React.useContext(Context)

  if (!route) throw new Error('useRoute must be used within a RouteProvider')

  return route
}
